console.log("Hey you, what do you think your looking at");
